import type { Assessment } from "../assessment-types";

export const HYPERVIGILANCE_ASSESSMENT: Assessment = {
  slug: "hypervigilance",
  emoji: "👁️",
  title: "Hypervigilance",
  tagline: "Living in a heightened state of alertness",
  intro:
    "This reflects on how often you might feel 'on alert', scanning for danger or watching for signs that something is wrong. There are no right answers, just patterns worth noticing.",
  questions: [
    { id: "q1", text: "Do you find yourself scanning a room or situation for possible danger?" },
    { id: "q2", text: "Do you startle easily at sudden noises or movements?" },
    { id: "q3", text: "Do you find it hard to relax, even when things seem calm?" },
    { id: "q4", text: "Do you notice yourself watching people's faces closely for signs of anger or upset?" },
    { id: "q5", text: "Do you feel on edge in crowded or unfamiliar places?" },
    { id: "q6", text: "Do you find it difficult to fall or stay asleep because your mind won't switch off?" },
    { id: "q7", text: "Do you feel like you always need to know what's happening around you?" },
    { id: "q8", text: "Do you notice tension in your body, such as a tight jaw or clenched shoulders, without realising why?" },
    { id: "q9", text: "Do you feel uneasy when you can't see an exit or escape route?" },
    { id: "q10", text: "Do you find it hard to switch off from checking on people you care about?" },
    { id: "q11", text: "Do you feel exhausted from being alert for long periods?" },
    { id: "q12", text: "Do you notice yourself expecting something to go wrong, even when things are going fine?" },
  ],
  bands: [
    {
      key: "low",
      minPercent: 0,
      headline: "Your answers suggest heightened alertness shows up rarely for you right now.",
      body:
        "It sounds like you're generally able to settle into calm moments. It's still worth noticing the situations where alertness rises for you.",
    },
    {
      key: "some",
      minPercent: 30,
      headline: "You may recognise some patterns related to a heightened state of alertness.",
      body:
        "Staying alert to your surroundings can be a helpful skill in the right dose, but it can also linger after a threat has passed. Noticing when it switches on is a useful first step.",
    },
    {
      key: "often",
      minPercent: 55,
      headline: "Your answers suggest you may often experience a heightened state of alertness.",
      body:
        "This can develop when your nervous system has learned to expect danger, even when things are currently safe. It made sense as a protective response, though it can be tiring to carry.",
    },
    {
      key: "high",
      minPercent: 78,
      headline: "Your answers suggest you may often experience a heightened state of alertness.",
      body:
        "Being on high alert this consistently can wear down your energy and make rest feel out of reach. This pattern usually has a clear history, and it's possible to gradually help your body feel safer.",
    },
  ],
  next: [
    { label: "Explore the polyvagal ladder", to: "/learn/polyvagal-ladder" },
    { label: "Understand triggers", to: "/learn/triggers" },
    { label: "Explore trauma and sleep", to: "/learn/trauma-sleep" },
    { label: "Try a grounding exercise", to: "/grounding" },
  ],
};
